import { dispatcher, Action } from './dispatcher';

export default function action(actionType, payload) {
	if(!payload) {
		payload = {};
	}

	console.log(actionType, payload);

	dispatcher.dispatch(new Action(actionType, payload));
}


// WEBPACK FOOTER //
// ./src/modules/utils/action.js